export enum INSURER_VALUE_TYPE {
  FIXED = 'F',
  PERCENTAGE = 'P',
}

export enum INSURER_STATUS {
  ACTIVE = 'A',
  DE_ACTIVE = 'DA',
}
